import { LOCALES } from "../locales";
import { englishText } from "./english";
import { spanishText } from "./spanish";

export const messages = {
  [LOCALES.ENGLISH]: englishText,
  [LOCALES.SPANISH]: spanishText
}